<template>
  <div>
    <router-view />
  </div>
</template>

<script setup>
import { ref,reactive } from "vue";
//import HelloWorld from './components/HelloWorld.vue'
import { ElNotification } from 'element-plus'
import {getOrderLast} from '@/api/orderProduct';
import { setToken,getToken } from "@/utils/index";



let orderIdLast = ref(0)

if(getToken()){

  //定时轮询 获取最新的订单
  // setInterval( async () => {

  //   let response =  await getOrderLast()
  //   if(response.data.code==1){

  //     if(response.data.data.id > orderIdLast.value){

  //       if(orderIdLast.value > 0){

  //         //提示通知
  //         ElNotification({
  //           title: '新订单',
  //           message: '你有新的订单,请及时处理',
  //           type: 'success',
  //           offset: 100,
  //           duration:8000
  //         })

  //         //提示声音
  //         console.log("提示声音")
  //         playMusic();

  //       }
        
  //       //记录最后的订单id
  //       orderIdLast.value = response.data.data.id

  //     }

  //   }

  // }, 10000);
  
}



/*播放音频*/
function playMusic() {

  //sound-play 播放
  //sound.play(processCwd + "/Alipay.mp3");


  //node 播放
  //cmd.runSync(processCwd + "/Alipay.mp3")

  //浏览器 播放
  //var mp3Url = require(processCwd + "/Alipay.mp3") ;
  var mp3Url = require("@/assets/audio/new_order.mp3") ; //require('@/assets/logo1.png'),
  var mp3 = new Audio(mp3Url);
  mp3.play(); //播放 mp3这个音频对象

}



</script>

<style>

body{
  padding: 0px;
  margin: 0px;

}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}



</style>
